import { redirectUnauthenticatedUser } from './redirectUnauthenticatedUser'

const apiLogoutUrl = `${process.env.VUE_APP_API_BASE_URL}/api/v1/logout?redirect_uri=${process.env.VUE_APP_BASE_URL}`

function logout (to, from, next) {
  redirectUnauthenticatedUser(apiLogoutUrl)
}

export { logout, apiLogoutUrl }
